interface TrendingItem {
  id: string;
  name: string;
  label: string;
  category: string;
  hot: boolean;
  imageUrl: string;
}

const trendingItems: TrendingItem[] = [
  {
    id: 't1',
    name: 'Premium Sneaker Collection',
    label: 'Check Sheet',
    category: 'Shoes',
    hot: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20white%20and%20cream%20sneakers%20placed%20on%20polished%20marble%20floor%20surface%2C%20dramatic%20golden%20hour%20sunlight%20casting%20long%20shadows%20through%20large%20window%2C%20luxury%20minimal%20interior%20setting%2C%20soft%20warm%20glow%2C%20editorial%20footwear%20photography%2C%20high%20contrast%20light%20and%20shadow%20composition%2C%20sophisticated%20product%20styling&width=560&height=420&seq=trending-sneakers-v2-2026&orientation=landscape',
  },
  {
    id: 't2',
    name: 'Designer Hoodie Drops',
    label: 'Check Sheet',
    category: 'Hoodies / Sweaters',
    hot: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=Oversized%20designer%20hoodie%20draped%20casually%20over%20a%20mid%20century%20wooden%20chair%20near%20a%20sunlit%20window%2C%20trailing%20ivy%20plant%20on%20windowsill%20creating%20organic%20shadow%20patterns%2C%20warm%20oatmeal%20and%20cream%20tones%2C%20cozy%20editorial%20interior%20photography%2C%20soft%20morning%20light%2C%20lifestyle%20fashion%20catalog%20aesthetic&width=560&height=420&seq=trending-hoodies-v2-2026&orientation=landscape',
  },
  {
    id: 't3',
    name: 'Limited Edition Tees',
    label: 'Check Sheet',
    category: 'T-Shirts',
    hot: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=Three%20premium%20cotton%20t-shirts%20neatly%20folded%20and%20stacked%20on%20white%20linen%20bedding%2C%20morning%20sunlight%20streaming%20through%20sheer%20curtains%20creating%20soft%20diffused%20glow%2C%20pastel%20sage%20green%20and%20warm%20beige%20color%20palette%2C%20serene%20bedroom%20editorial%20scene%2C%20clean%20Scandinavian%20aesthetic%2C%20relaxed%20lifestyle%20photography&width=560&height=420&seq=trending-tees-v2-2026&orientation=landscape',
  },
  {
    id: 't4',
    name: 'Vintage Jacket Finds',
    label: 'Check Sheet',
    category: 'Jackets',
    hot: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=Vintage%20washed%20denim%20jacket%20hanging%20on%20antique%20brass%20wall%20hook%20against%20textured%20plaster%20wall%2C%20warm%20amber%20accent%20lighting%20from%20side%20creating%20dramatic%20shadow%2C%20rustic%20industrial%20interior%20with%20exposed%20brick%20detail%2C%20editorial%20fashion%20photography%2C%20moody%20warm%20tones%2C%20artisanal%20craftsmanship%20aesthetic&width=560&height=420&seq=trending-jackets-v2-2026&orientation=landscape',
  },
];

export default function TrendingSection() {
  return (
    <section className="relative w-full py-24 md:py-32 px-6 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-800 text-center mb-14">
          Trending This Week
        </h2>

        <div className="flex gap-5 overflow-x-auto pb-4 -mx-2 px-2">
          {trendingItems.map((item) => (
            <a
              key={item.id}
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="flex-shrink-0 w-[260px] md:w-[280px] rounded-2xl bg-background-50 border border-background-200/60 hover:border-accent-300 transition-all duration-200 overflow-hidden cursor-pointer group"
            >
              <div className="relative h-48 md:h-52 overflow-hidden bg-background-200">
                {item.hot && (
                  <span className="absolute top-3 left-3 z-10 px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider bg-primary-500 text-background-50">
                    Hot
                  </span>
                )}
                <img
                  src={item.imageUrl}
                  alt={item.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={`${item.name} - Hipobuy Spreadsheet`}
                />
              </div>
              <div className="p-4 md:p-5 text-center">
                <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-800 mb-1">
                  {item.name}
                </h3>
                <p className="text-xs text-foreground-400">{item.label}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}